import { __module as t } from "../../../../_virtual/assertString.js";
!function (t, o) {
  function e(t) {
    return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = function (t) {
    if (!("string" == typeof t || t instanceof String)) {
      var o = e(t);
      throw null === t ? o = "null" : "object" === o && (o = t.constructor.name), TypeError("Expected a string but received a ".concat(o));
    }
  }, t.exports = o.default, t.exports.default = o.default;
}(t, t.exports);
var o = t.exports;
export { o as a };